module.exports = __webpack_public_path__ + "static/img/A113.6215ed82.jpg";